import { IVacationBidPackage, IVacationBidPackageListItem, IVacationBidSlot } from "@vmosolutions/oc-interfaces";

// ---------------------------------------------------------------------------
// Mosaic window props
// ---------------------------------------------------------------------------

export interface IVacationBidPackageListWindowProps {
  id: string;
  path: string[];
  windowProps?: object;
}

export interface IVacationBidPackageEditorWindowProps {
  id: string;
  path: string[];
  windowProps: {
    /** Opens the editor on an existing package, fetched by id. */
    vacationBidPackageListItem?: IVacationBidPackageListItem;
    /** A fully loaded package, set by the editor itself after a save. */
    vacationBidPackage?: IVacationBidPackage;
    /** Load the package but clear its id, so saving creates a copy. */
    duplicate?: boolean;
  };
}

// ---------------------------------------------------------------------------
// Editor tab contracts
// Each tab owns its own API calls and reports results back to the editor.
// ---------------------------------------------------------------------------

interface IEditorTabBaseProps {
  id: string;
  path: string[];
  /** Portal target for react-select menus so they escape the accordion's overflow. */
  mosaicPane: HTMLElement | null;
  /** Names the files a tab exports. Absent until the package has been given a title. */
  packageTitle?: string;
}

export interface IVacationCrewTabProps extends IEditorTabBaseProps {
  packageId: string | undefined;
  /** The Formik `crewGroups` value. The field inside the tab is bound to that name. */
  crewGroups: string[];
  initialCrewGroups: string[];
  /** Incremented by the editor after every save so the tab refetches its crew rows. */
  crewVersion: number;
}

export interface IVacationSlotsTabProps extends IEditorTabBaseProps {
  packageId: string | undefined;
  /** The saved slot table. The tab keeps its own working copy until the admin saves it. */
  slots: IVacationBidSlot[];
  bidBlockStart: Date | string | undefined;
  bidBlockEnd: Date | string | undefined;
  /** When true, existing slots may not be removed or re-dated; capacity and include stay editable. */
  slotsProtected: boolean;
  showSlotIdYear: boolean;
  /** Called with the saved package once the slot table is persisted, so the editor reinitializes. */
  onSlotsSaved: (pkg: IVacationBidPackage) => void;
}

// ---------------------------------------------------------------------------
// List window
// ---------------------------------------------------------------------------

export interface IStatusFilterOption {
  label: string;
  value: string;
  color: string | null;
}

export const EDITOR_TAB = {
  details: 0,
  crew: 1,
  slots: 2,
  bids: 3,
  awards: 4,
  manage: 5,
  importAwards: 6,
} as const;

export const WINDOW_TITLE = {
  list: "Vacation Bid Management",
  newPackage: "New Vacation Bid Package",
  editPackage: "Edit Vacation Bid Package",
} as const;
